import { Container, Sprite, Texture } from '../../../odie';

import { ColorId, DoorBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const overlayProps = [
  null,
  {
    asset: 'door/scrap.chains.0.png',
    x: -1,
    y: 1,
  },
  {
    asset: 'door/scrap.chains.1.png',
    x: -4,
    y: 1,
  },
];

const colorMap: { [key in ColorId]?: string } = {
  all: 'door/block.door.all.png',
  blue: 'door/block.door.blue.png',
  green: 'door/block.door.green.png',
  purple: 'door/block.door.purple.png',
  red: 'door/block.door.red.png',
  yellow: 'door/block.door.yellow.png',
};

/*
    door block view
*/
export class DoorBlockView extends Container {
  // fields
  //-------------------------------------------------------------------------
  // scene
  public _overlay: Sprite;
  // state
  private _count = 0;

  // properties
  //-------------------------------------------------------------------------
  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    const props = overlayProps[value];
    const overlay = this._overlay;

    // update field
    this._count = value;

    // if props exist for this count, enable overlay from props
    if (props) {
      overlay.texture = Texture.from(props.asset);
      overlay.x = props.x;
      overlay.y = props.y;
      overlay.visible = true;
      // else hide it
    } else {
      overlay.visible = false;
    }
  }

  // init
  //-------------------------------------------------------------------------
  constructor(props: DoorBlockProps) {
    if (!props.color) throw new Error('[DoorBlockView] color is required');
    // create base view
    super();
    const sprite = new FitWidthBlockSprite(colorMap[props.color] ?? '', props);
    this.addChild(sprite);
    blockPositionView(this, props);

    // create count view
    const overlay = (this._overlay = new Sprite());
    overlay.anchorX = overlay.anchorY = 0.5;
    sprite.addChild(overlay);
  }

  public static assets(props: DoorBlockProps): string[] {
    if (!props.color) throw new Error('[DoorBlockView] color is required');
    return [
      colorMap[props.color] ?? '',
      ...Object.values(overlayProps).map((object) => object?.asset ?? ''),
    ];
  }
}
